import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
} from '@mui/material';
import { useTenantStore } from '../../../stores/tenant.store';
import { useAcademic } from '../../../hooks/use-academic';
import { DocumentData } from 'firebase/firestore';

interface DeleteCourseDialogProps {
  open: boolean;
  onClose: () => void;
  course: DocumentData | null;
}

export function DeleteCourseDialog({ open, onClose, course }: DeleteCourseDialogProps) {
  const { currentTenantId } = useTenantStore();
  const { deleteCourse, isDeletingCourse } = useAcademic();
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    if (!currentTenantId || !course) return;
    setError(null);
    try {
      await deleteCourse({
        tenantId: currentTenantId,
        courseId: course.id,
      });
      onClose();
    } catch (err: any) {
      setError(err.message || 'Error deleting course');
    }
  };

  if (!course) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Eliminar Curso</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Typography>
          ¿Estás seguro que deseas eliminar el curso <strong>{course.name}</strong> ({course.code})?
          Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={isDeletingCourse}>
          Cancelar
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          color="error"
          disabled={isDeletingCourse}
        >
          {isDeletingCourse ? 'Eliminando...' : 'Eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
